import React from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from 'react-router-dom';
import Layout from 'presentation/components/templates/Layout';
import Home from 'presentation/pages/Home';
import Meeting from 'presentation/pages/Meeting';
import NoMatch from 'presentation/pages/NoMatch';

const ROUTES = createBrowserRouter(
  createRoutesFromElements(
    <Route path='/zoom' element={<Layout />}>
      <Route index element={<Home />} />
      <Route path='meeting/:meetingId' element={<Meeting />} />
      <Route path='*' element={<NoMatch />} />
    </Route>
  )
);

export default ROUTES;
